import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, showDetails: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null, showDetails: false });
  };

  render() {
    if (this.state.hasError) {
      const darkMode = this.props.darkMode;
      const errMsg = this.state.error ? this.state.error.toString() : 'Unknown error';
      const stack = this.state.errorInfo?.componentStack || '';
      return (
        <div className={`flex flex-col items-center justify-center min-h-[300px] p-8 text-center rounded-2xl border ${darkMode ? 'bg-slate-800/60 border-slate-700/50' : 'bg-white border-slate-100'}`}>
          <div className="text-4xl mb-4">⚠️</div>
          <h3 className={`text-lg font-bold mb-2 ${darkMode ? 'text-slate-100' : 'text-slate-800'}`}>
            {this.props.language === 'en' ? 'Something went wrong' : 'เกิดข้อผิดพลาด'}
          </h3>
          <p className={`text-sm mb-4 max-w-md ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
            {this.props.language === 'en'
              ? 'This section failed to load. Please try again.'
              : 'ส่วนนี้โหลดไม่สำเร็จ กรุณาลองอีกครั้ง'}
          </p>
          <button
            onClick={this.handleRetry}
            className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all ${darkMode ? 'bg-indigo-600 hover:bg-indigo-500 text-white' : 'bg-indigo-500 hover:bg-indigo-600 text-white'}`}
          >
            {this.props.language === 'en' ? '🔄 Retry' : '🔄 ลองอีกครั้ง'}
          </button>
          <button
            onClick={() => this.setState(prev => ({ showDetails: !prev.showDetails }))}
            className={`mt-3 text-[10px] underline ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}
          >
            {this.state.showDetails ? 'Hide details' : 'Show error details'}
          </button>
          {this.state.showDetails && (
            <pre className={`mt-3 text-[9px] text-left max-w-full overflow-auto p-3 rounded max-h-40 ${darkMode ? 'text-red-400 bg-slate-900' : 'text-red-600 bg-red-50'}`}>
              {errMsg}
              {stack ? '\n\nComponent Stack:' + stack.slice(0, 500) : ''}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
